import { defineMessages } from 'react-intl';

const _default_1: {
	closePreviewLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	closePreviewLabel: {
		id: 'fabric.editor.ai.components.closePreviewIconButton.closePreviewLabel.non-final',
		defaultMessage: 'Close preview',
		description: 'Close preview button label and tooltip',
	},
});
export default _default_1;
